<app-dialog
  [dialogType]="dialogType"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject"
  [hideActions]="true"
>
  <div *ngIf="feedbackScreen$ | async; else loader" class="dialog-content">
    <p class="title">{{ title$ | async }}</p>

    <p class="subtitle">{{ subtitle$ | async }}</p>

    <i2g-form-master *ngIf="formGroup$ | async as formGroup" [form]="formGroup">
      <div
        *ngFor="let field of formFields$ | async | keyvalue"
        class="input-fields-wrapper"
      >
        <div *ngIf="field.value?.type === screenInputTypesEnum.radio_button">
          <div
            *ngFor="let choice of field.value?.options; let i = index"
            class="input-field-wrapper"
          >
            <i2g-radio-field
              class="reason-field"
              [group]="field.key"
              e2eId="reason-{{ i }}"
              fieldId="reason-{{ i }}"
              [label]="choice.key"
              [value]="choice.value"
              [trackingObject]="trackingObject"
              [trackingTapped]="buildRadioTappedTrackingAction(choice.value)"
              [fieldControl]="formGroup.get(field.key)"
            >
            </i2g-radio-field>
          </div>

          <app-error-message
            *ngIf="
              formGroup.dirty && formGroup.get(field.key)?.errors?.required
            "
            [errorMessage]="'ERROR.FIELD_REQUIRED' | translate"
          >
          </app-error-message>

          <div
            *ngIf="
              field.value?.optional_text &&
              formGroup.get(field.key).value ===
                field.value.optional_text.radio_button.input_id
            "
          >
            <i2g-textarea-field
              class="input-field-wrapper has-optional-text"
              [label]="field.value.optional_text.comment.label"
              [placeholder]="field.value.optional_text.comment.placeholder"
              [fieldId]="field.value.optional_text.comment.input_id"
              [fieldControl]="
                formGroup.get(field.value.optional_text.comment.input_id)
              "
              [maxlength]="1000"
              [focusableTrigger$]="focusableTrigger$"
              [textareaE2eId]="field.value.optional_text.comment.input_id"
            >
            </i2g-textarea-field>
          </div>
        </div>
      </div>

      <div class="cta-buttons">
        <button
          i2gButton
          buttonStyle="emphasis"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="submitTrackingAction"
          (click)="onSubmit(formGroup)"
        >
          {{ primaryActionText$ | async }}
        </button>

        <button
          i2gButton
          buttonStyle="tertiary"
          class="secondary-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="cancelTrackingAction"
          (click)="closeDialog(formGroup)"
        >
          {{ secondaryActionText || (secondaryActionText$ | async) }}
        </button>
      </div>
    </i2g-form-master>
  </div>

  <ng-template #loader>
    <div class="loading-dialog-content">
      <app-icon class="loading-spinner" [icon]="loadingSpinnerIcon"> </app-icon>
    </div>
  </ng-template>
</app-dialog>
